import WkImportVue from './index.vue';

var WkImport = {};

WkImport.install = function (Vue) {
  var WkCRMImportConstructor = Vue.extend(WkImportVue);
  var instance = new WkCRMImportConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);

  Vue.prototype.$wkImport = instance;
};

export default WkImport;